export const brands = {
  tmedical: "TMEDICAL",
  medihub: "PARTNER_CODE_1",
};
